import {Provider} from '@angular/core';

import {
  MyCustomerDataUseCaseProvider
} from '@features/customer/presentation/providers/my-customer-data/my-customer-data.use-case.provider';

import {MyCustomerDataFacade} from '@features/customer/presentation/facades/my-customer-data/my-customer-data.facade';

export const MyCustomerDataFacadeProvider: Provider[] = [
  MyCustomerDataUseCaseProvider,
  MyCustomerDataFacade
];
